<template>
    <div class="CardForm">
        <Row>
            <Column :md="6">
                <FormInput
                    v-model="$v.firstName.$model"
                    lazy
                    label="First Name"
                    :errors="$v.firstName.$error ? [
                        !$v.firstName.required && 'First name is required',
                    ] : null"
                />
            </Column>
            <Column :md="6">
                <FormInput
                    v-model="$v.lastName.$model"
                    lazy
                    label="Last Name"
                    :errors="$v.lastName.$error ? [
                        !$v.lastName.required && 'Last name is required',
                    ] : null"
                />
            </Column>
        </Row>

        <AddressForm
            ref="addressForm"
            :address.sync="$v.address.$model"
            :city.sync="$v.city.$model"
            :state.sync="$v.state.$model"
            :zip.sync="$v.zip.$model"
            lazy
            required
        />

        <FormStripeCard v-model="card"/>
    </div>
</template>

<script>
import * as api from '@/api';
import FormStripeCard from '@/components/common/FormStripeCard';
import AddressForm from './AddressForm';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'CardForm',

    components: { FormStripeCard, AddressForm },

    syncProps: [
        'firstName',
        'lastName',
        'address',
        'city',
        'state',
        'zip',
    ],

    data: () => ({
        card: null,
    }),

    validations: {
        firstName: { required },
        lastName: { required },
        address: { required },
        city: { required },
        state: { required },
        zip: { required },
    },

    methods: {
        validate() {
            this.$v.$touch();
            if (!this.$refs.addressForm.validate()) {
                return false;
            }

            return !this.$v.$invalid;
        },
    },
}
</script>
